import axios from 'axios';
import * as utils from '@/apis/apiUtils';
import type { AxiosResponse } from 'axios';
import type {
  StandardMtxsCreateParams,
  StandardMtxGetParams,
} from '@/models/apis/externalReports/standard/standardMtxRequest';
import type { StandardMtx } from '@/models/externalReports/standard/standardMtx';
import type { StandardMtxResponse } from '@/models/apis/externalReports/standard/standardMtxResponse';
import type { EmptyResponse } from '@/models/index';

export default {
  createStandardMTXs(params: StandardMtxsCreateParams): Promise<AxiosResponse<EmptyResponse>> {
    return axios.post(utils.getApiUrl('/external_reports/standard/mtxs'), params);
  },
  async getMtxsByReportIds(params: StandardMtxGetParams): Promise<Record<number, StandardMtx[]>> {
    const { data } = await axios.get<StandardMtxResponse[]>(utils.getApiUrl('/external_reports/standard/mtxs'), {
      params: params || {},
    });
    return convertStandardMtxResponseToStandardMtx(data);
  },
};

function convertStandardMtxResponseToStandardMtx(standardMtx: StandardMtxResponse[]): Record<number, StandardMtx[]> {
  const result: Record<number, StandardMtx[]> = {};

  standardMtx.forEach(item => {
    const model: StandardMtx = {
      externalReportsStandardCarId: Number(item.external_reports_standard_car_id),
      ts: new Date(item.ts),
      lat: Number(item.lat),
      lon: Number(item.lon),
      status: item.status,
      externalReportsStandardReportId: item.external_reports_standard_report_id,
    };

    if (!result[item.external_reports_standard_report_id]) {
      result[item.external_reports_standard_report_id] = [];
    }
    result[item.external_reports_standard_report_id].push(model);
  });

  return result;
}
